/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAIcon24Solid = forwardRef('MediaAudioMicAIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 1a4.5 4.5 0 0 0-4.5 4.5V11a4.5 4.5 0 1 0 9 0V5.5A4.5 4.5 0 0 0 12 1Z" }),
        React.createElement("path", { d: "M4.75 9.125c.621 0 1.125.504 1.125 1.125V11a6.125 6.125 0 0 0 12.25 0v-.75a1.125 1.125 0 0 1 2.25 0V11a8.377 8.377 0 0 1-7.25 8.3v1.705H16a1.125 1.125 0 0 1 0 2.25H8a1.125 1.125 0 0 1 0-2.25h2.875V19.3a8.377 8.377 0 0 1-7.25-8.3v-.75c0-.621.504-1.125 1.125-1.125Z" })));
});
